import React from "react";
import { Text, Box, Drawer, Group, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import DiscountSpecialData from "./DiscountSpecialData";

const DiscountSpecialView = ({
    stateShow,
    fnShow,
    stateData,
}) => {
    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>View Data Diskon Khusus</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>
                    <Text
                        size="sm"
                        mb='2rem'
                    >
                        <DiscountSpecialData
                            stateData={stateData}
                        />
                    </Text>
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default DiscountSpecialView;